module.exports = __webpack_public_path__ + "img/route-point.2095936f.svg";